import { Link } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Header />
      <main className="flex flex-col items-center justify-center text-center px-4 py-32 md:py-40">
        <p className="font-heading text-7xl md:text-9xl font-bold text-primary-500 select-none">
          404
        </p>
        <h1 className="mt-6 text-2xl md:text-3xl font-semibold font-heading text-foreground-950">
          This page doesn&apos;t exist.
        </h1>
        <p className="mt-3 text-base text-foreground-600 max-w-md leading-relaxed">
          The page you&apos;re looking for may have moved, or the link is outdated. Let&apos;s get you back on track.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-md text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors"
          >
            <i className="ri-home-line w-4 h-4 flex items-center justify-center" />
            Back to home
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-background-50 border border-background-300 hover:border-accent-500 hover:text-accent-700 text-foreground-800 px-6 py-3 rounded-md text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors"
          >
            Contact us
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}